import React from 'react';
import { MainPage } from './pages/mainpage';

function App() {
  return (
    <div className="App">
      <h1>현재 제작중으로, 오류가 있을 수 있습니다</h1>
      <MainPage/>
    </div>
  );
}

export default App;
